import React from 'react';
import { AudioDataModule } from '@ibe/tupvid-components';
import BlankPageLayout from '../Layouts/BlankPageLayout';

const MasterData = (): JSX.Element => {
  return (
    <BlankPageLayout>
      <div>
        <AudioDataModule />
      </div>
    </BlankPageLayout>
  );
};
export default MasterData;
